import React from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Toolbars as ToolBarContainer } from '../../../components/Card/CardHeaderWithToolbars'
import propTypes from 'prop-types';
import { FontAwesomeIcon } from '../../../components/Icons';

export const Toolbars = props => (
  <ToolBarContainer>
    <Link
      to={'/product_addons/create'}
      className="btn btn-sm btn-primary with-toolbars__toolbars__btn"
      title="Create new product addon"
      target="_blank"
    >
      <FontAwesomeIcon iconType="plus"/>
    </Link>
    <Button
      title="Refresh"
      className="with-toolbars__toolbars__btn"
      size="sm"
      color="info"
      onClick={props.onRefreshList}>
      <FontAwesomeIcon iconType="refresh"/>
    </Button>
    <Button
      title="Reset filter"
      className="with-toolbars__toolbars__btn"
      size="sm"
      color="warning"
      onClick={props.onResetFilter}>
      <FontAwesomeIcon iconType="ban"/>
    </Button>
    <Button
      title="Search and Filter Data"
      size="sm"
      className={classNames("with-toolbars__toolbars__btn",{"btn-danger":props.isOpen})}
      onClick={props.onToggleFilter}>
      <i className={classNames("fa",{"fa-sliders":!props.isOpen, "fa-minus":props.isOpen})}></i>
    </Button>
  </ToolBarContainer>
)

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onToggleFilter: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func
}
Toolbars.defaultProps = {
  isOpen: false
}